import {Injectable} from '@angular/core';
import {Headers, Http, Response} from '@angular/http';
import 'rxjs/add/operator/toPromise';
import {webapi} from '../../shared/my-constants';

@Injectable()
export class TrnSponsorCombinationService {
    trnSponsorCombination: any;
    private headers = new Headers({'Content-Type': 'application/json'});
    private ListRecord = webapi + 'trn_sponsor_combination/list/?';
    private ListByVisitId = webapi + 'trn_sponsor_combination/listbyvisitId?visitID=';
    private AddRecord = webapi + 'trn_sponsor_combination/create';
    private EditRecord = webapi + 'trn_sponsor_combination/update';
    private GetRecord = webapi + 'trn_sponsor_combination/byid/';
    private DeleteRecord = webapi + 'trn_sponsor_combination/delete/';
    private DeleteRecordByUserId = webapi + 'trn_sponsor_combination/deletebyuserid/';
    private ListRecordbyuser = webapi + 'trn_sponsor_combination/listbyuserforedit/?userID=';
    private AddRecordDefault = webapi + 'trn_sponsor_combination/createdefault/?userID=';
    private AddRecordDefaultvalidate = webapi + 'trn_sponsor_combination/createdefaultvalidate/?userID=';
    private adddefault = webapi + 'trn_sponsor_combination/byuserid/';
// mht95.00
    private ListRecordByUserId = webapi + 'trn_sponsor_combination/listsponsorsbyuser/';
    private ListByUserId = webapi + 'trn_sponsor_combination/listbyuser?';
    private GetRecordByVisitId = webapi + 'trn_sponsor_combination/byvisitId/';
    private GetAdmissionIdByPatientIdRecent = webapi + 'trn_admission/getAdmissionIdByPatientIdRecent/';
    private UpdateAdmissionSpId = webapi + 'trn_admission/updateAdmissionSpId/';

    constructor(private http: Http) {
    }

    getdefaultadd(user_id: any): Promise<any> {
        return this.http.get(this.adddefault + user_id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAdmissionIdByPatientIdRecent(patientId: any): Promise<any> {
        return this.http.get(this.GetAdmissionIdByPatientIdRecent + patientId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    updateAdmissionSpId(admissionId: any, scId: any): Promise<any> {
        return this.http.get(this.UpdateAdmissionSpId + admissionId + '/' + scId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    addRecorddefaultService(user_id: any, visit_id: any) {
        return this.http.get(this.AddRecordDefault + user_id + '&visitID=' + visit_id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    addRecorddefaultServicevalidate(user_id: any, visit_id: any) {
        return this.http.get(this.AddRecordDefaultvalidate + user_id + '&visitID=' + visit_id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllRecordService(currentPage: any, size: any, qString: any, sort: any, col: any): Promise<any> {
        return this.http.get(this.ListRecord + 'page=' + currentPage + '&size=' + size + '&qString=' + '' + '&sort=' + sort + '&col=' + col)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllRecordServicebyuser(user_id: any): Promise<any> {
        return this.http.get(this.ListRecordbyuser + user_id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllRecordServiceByVisitId(visit_id: any): Promise<any> {
        return this.http.get(this.ListByVisitId + visit_id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    addRecordService(model: any) {
        return this.http.post(this.AddRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    editRecordService(model: any) {
        return this.http.put(this.EditRecord, JSON.stringify(model), {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    deleteRecordService(id: any) {
        return this.http.put(this.DeleteRecord + id, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    deleteRecordByUserIdService(id: any) {
        return this.http.put(this.DeleteRecordByUserId + id, {headers: this.headers})
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getRecordService(id: any) {
        return this.http.get(this.GetRecord + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

//  URL for getting sponsors by patient's user id
    getAllRecordServicebyuserId(patientUserId: any): Promise<any> {
        return this.http.get(this.ListRecordByUserId + patientUserId)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    getAllRecordbyuserId(userID: any): Promise<any> {
        return this.http.get(this.ListByUserId + 'userID=' + userID)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }

    private handleError(error: Response | any) {
        return Promise.reject(error.message || error);
    }

    getRecordByVisitIDService(id: any) {
        return this.http.get(this.GetRecordByVisitId + '?visitID=' + id)
            .toPromise()
            .then(response => response.json())
            .catch(this.handleError);
    }
}




// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/configuration/trn-sponsor-combination/trn-sponsor-combination.service.ts